import routeParams from '../../../../helpers/routeParams'
import { INVITED_PARTICIPANTS_BULK } from '../../../../constants/enums'
import { sameIdsIn } from '../../../../utils/array'

const GET_TASKS_INVITED_PARTICIPANTS = 'dofe-bo/invitedParticipantsTasks/GET_TASKS_INVITED_PARTICIPANTS'
const GET_TASKS_INVITED_PARTICIPANTS_SUCCESS = 'dofe-bo/invitedParticipantsTasks/GET_TASKS_INVITED_PARTICIPANTS_SUCCESS'
const GET_TASKS_INVITED_PARTICIPANTS_FAIL = 'dofe-bo/invitedParticipantsTasks/GET_TASKS_INVITED_PARTICIPANTS_FAIL'

const SET_FILTER = 'dofe-bo/invitedParticipantsTasks/SET_FILTER'
const SET_PARAMS = 'dofe-bo/invitedParticipantsTasks/SET_PARAMS'

const BULK_PROCESS_RESET = 'dofe-bo/invitedParticipantsTasks/BULK_RESEND_RESET'
const BULK_PROCESS = 'dofe-bo/invitedParticipantsTasks/BULK_PROCESS'
const BULK_PROCESS_SUCCESS = 'dofe-bo/invitedParticipantsTasks/BULK_PROCESS_SUCCESS'
const BULK_PROCESS_FAIL = 'dofe-bo/invitedParticipantsTasks/BULK_PROCESS_FAIL'

const BULK_INVITED_PARTICIPANTS_RESET = 'dofe-bo/invitedParticipantsTasks/BULK_INVITED_PARTICIPANTS_RESET'

const SET_TASKS_INVITED_PARTICIPANTS_SELECTED = 'dofe-bo/invitedParticipantsTasks/SET_TASKS_INVITED_PARTICIPANTS_SELECTED'
const TOGGLE_TASKS_INVITED_PARTICIPANTS_ALL_SELECTED = 'dofe-bo/invitedParticipantsTasks/TOGGLE_TASKS_INVITED_PARTICIPANTS_ALL_SELECTED'

const DELETE_INVITED_PARTICIPANT = 'dofe-bo/invitedParticipantsTasks/DELETE_INVITED_PARTICIPANT'
const DELETE_INVITED_PARTICIPANT_SUCCESS = 'dofe-bo/invitedParticipantsTasks/DELETE_INVITED_PARTICIPANT_SUCCESS'
const DELETE_INVITED_PARTICIPANT_FAIL = 'dofe-bo/invitedParticipantsTasks/DELETE_INVITED_PARTICIPANT_FAIL'

const RESEND_INVITATION_EMAIL = 'dofe-bo/invitedParticipantsTasks/RESEND_INVITATION_EMAIL'
const RESEND_INVITATION_EMAIL_SUCCESS = 'dofe-bo/invitedParticipantsTasks/RESEND_INVITATION_EMAIL_SUCCESS'
const RESEND_INVITATION_EMAIL_FAIL = 'dofe-bo/invitedParticipantsTasks/RESEND_INVITATION_EMAIL_FAIL'

const initialState = {
  list: [],
  count: null,
  filter: '',
  sort: '',
  offset: 0,
  limit: 10,
  pages: 1,
  loading: false,
  loaded: false,
  importLoading: false,
  importData: [],
  selectedIds: [],
  bulk: {
    loading: false,
    loaded: false
  },
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_INVITED_PARTICIPANTS:
      return {
        ...state,
        loading: true
      }

    case GET_TASKS_INVITED_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result || [],
        count: action.headers['x-total-count'],
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }

    case GET_TASKS_INVITED_PARTICIPANTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    case BULK_PROCESS_RESET:
      return {
        ...state,
        bulk: {
          loading: false,
          loaded: false
        }
      }
    case BULK_PROCESS:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: true,
          loaded: false
        }
      }
    case BULK_PROCESS_SUCCESS:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case BULK_PROCESS_FAIL:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
          error: action.error
        }
      }
    case BULK_INVITED_PARTICIPANTS_RESET:
      return {
        ...state,
        bulk: {
          loading: false,
          loaded: false
        }
      }
    case SET_TASKS_INVITED_PARTICIPANTS_SELECTED:
      return {
        ...state,
        selectedIds: action.selectedIds
      }
    case TOGGLE_TASKS_INVITED_PARTICIPANTS_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort
      }
    default:
      return state
  }
}

export function getTasksInvitedParticipants(params = {}, baseFilter) {
  return {
    types: [
      GET_TASKS_INVITED_PARTICIPANTS,
      GET_TASKS_INVITED_PARTICIPANTS_SUCCESS,
      GET_TASKS_INVITED_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/invited-participants?with=ORGANIZATION,PARTICIPANT_REGISTRATION${routeParams(params, baseFilter)}`
      )
  }
}

export function setTasksInvitedParticipantsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setTasksInvitedParticipantsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function bulkInvitedParticipantsReset() {
  return {
    type: BULK_INVITED_PARTICIPANTS_RESET
  }
}

export function bulkInvitedParticipantsProcess(selectedIds, bulkType) {
  const types = [
    BULK_PROCESS,
    BULK_PROCESS_SUCCESS,
    BULK_PROCESS_FAIL
  ]

  switch (bulkType) {
    case INVITED_PARTICIPANTS_BULK.resendInvitationEmail.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/tasks/invited-participants/resend-invitation-email/bulk',
            {
              data: {
                participantRegistrationIds: selectedIds.map(item => item.participantRegistrationId)
              }
            }
          )
      }

    case INVITED_PARTICIPANTS_BULK.delete.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/tasks/invited-participants/delete/bulk',
            {
              data: {
                taskIds: selectedIds.map(item => item.taskId)
              }
            }
          )
      }

    default:
      throw new Error(`${bulkType} not implemented`)
  }
}

export function setTasksInvitedParticipantsSelected(selectedIds) {
  return {
    type: SET_TASKS_INVITED_PARTICIPANTS_SELECTED,
    selectedIds
  }
}

export function toggleTasksInvitedParticipantsAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_TASKS_INVITED_PARTICIPANTS_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function deleteInvitedParticipant(taskId) {
  return {
    types: [DELETE_INVITED_PARTICIPANT, DELETE_INVITED_PARTICIPANT_SUCCESS, DELETE_INVITED_PARTICIPANT_FAIL],
    promise: client => client.del(`api/tasks/invited-participants/${taskId}/delete`)
  }
}

export function resendInvitationEmail(participantRegistrationId) {
  return {
    types: [RESEND_INVITATION_EMAIL, RESEND_INVITATION_EMAIL_SUCCESS, RESEND_INVITATION_EMAIL_FAIL],
    promise: client => client.post(`api/tasks/invited-participants/${participantRegistrationId}/resend-invitation-email`)
  }
}
